export default {
    "lang": "zh",
    "aboutGraceMed": "關於誠恩醫療",
    "ourHeadDoctor": "我們的主診醫生",
    "services": "服務範圍",
    "news": "媒體報道",
    "contactUs": "聯絡我們",

    "home1": "一切以您的健康為先",
    "home2": "<span>誠恩醫療</span> 創立於 2019 年，致力透過提供定期身體檢查和監察服務，協助您和您的親人維持健康的體魄。",
    "home3": "使命",
    "home4": "積極創新",
    "home5": "我們全力開拓，務求不斷提升服務品質，使您和一眾尊貴客戶能受惠於本公司提供的優質服務。",
    "home6": "本公司一直堅信「行動勝於空談」，因此從不間斷地確保能為客戶提供：",
    "home7": "服務理念",
    "home8": "在符合最為嚴格的醫療標準下，盡我們所能履行職責。",
    "home9": "恪守不違",
    "home10": "遵循政府法例和醫療行業的要求。",
    "home11": "誠心關愛",
    "home12": "細心聆聽和了解您和您家人的適切醫療需要。",

    "about1": "關於<span>誠恩醫療</span>",
    "about2": "誠恩醫療的病人可以選擇到港安醫院、嘉諾撒醫院、明德國際醫院、聖保祿醫院、養和醫院、浸會醫院、聖德肋撒醫院、港怡醫院和仁安醫院等私家醫院留醫。",
    "about22": "本診所不僅治理疾病，更會以完善整合和以實證為本的醫療服務，悉心關注病人的身體狀況，讓他們擁有更健康的身體。我們的首要目標是透過研製，且能反映您個人獨特狀況的創新藥物基因體學，來減低您對藥物的依賴。盡早作出診斷和治療，為您的終生健康開拓出第一步。",
    "about3": "我們的願景",
    "about4": "誠恩醫療醫護團隊相信只要大家更加關心和照料好自己的身體，便能預防患上多種慢性疾病。我們精心安排的整合治療方案，讓您終生享受健康的生活。",
    "about5": "<span>GraceMed</span> 是港安醫院、嘉諾撒醫院、明德國際醫院、聖保祿醫院、養和醫院、浸會醫院和聖德肋撒醫院等優質香港醫院的緊密合作夥伴。",
    "about6": "我們的主診醫生",

    "doctor1": "<span>曹忠豪</span>醫生",
    "doctor2": "Raymond 是馬薩諸塞州著名波士頓大學醫學院的榮譽畢業生，畢業後曾於紐約大學備受尊崇的萊諾克斯山醫院接受內科醫學課程的培訓。隨後，他更在紐約著名的阿爾伯特愛因斯坦醫學院參加了肺部和重症醫學培訓課程。",
    "doctor3": "其後曹忠豪醫生在紐約長老會醫院的哥倫比亞大學醫學中心醫院獲得更多有關肺部和心臟移植的培訓。 及後他返回亞洲後，透過香港醫務委員會的執照組考試獲得本地執業牌照，並在律敦治醫院開拓他的醫療事業。",
    "doctor4": "學歷",
    "doctor5": "美國馬薩諸塞州波士頓波士頓大學文理學院化學學士優等生",
    "doctor6": "美國馬薩諸塞州波士頓波士頓大學醫學院醫學博士",
    "doctor7": "美國紐約紐約大學 - 萊諾克斯山醫院住院醫生計劃的內科住院醫生",
    "doctor8": "美國紐約阿爾伯特愛因斯坦醫學院肺部和重症醫學研究獎學金",
    "doctor9": "專業資格",
    "doctor10": "美國內科醫學委員會2003年內科醫學認證 (2017年獲重新認證)",
    "doctor11": "美國內科醫學委員會2004年肺部醫學認證 (2017年獲重新認證)",
    "doctor12": "美國內科醫學委員會2009年重症護理醫學認證",
    "doctor13": "加州醫學委員會",
    "doctor14": "香港醫務委員會 (HKLMC)",
    "doctor15": "香港內科醫學院會員",
    "doctor16": "呼吸系統科專科醫生",

    "services1": "內科護理",
    "services2": "本診所致力提供病人護理服務，包括診斷和治療多種不同的病症，以及向社區大力宣傳預防醫學的重要性。除了提供一般醫療護理服務外，我們亦會因應每一位病人的個別需要，與專科醫護人員合作以提供如手術等進一步治療。",
    "services3": "肺部護理或呼吸內科護理",
    "services4": "我們致力於照顧哮喘或慢阻肺病等急性和慢性呼吸系統疾病的患者，同時協助病人處理有待診斷為呼吸系統疾病症狀的緊急情況。若診斷出問題，我們會按病人的需要安排治療計劃，減輕病人呼吸困難的情況。",
    "services5": "過敏及哮喘計劃",
    "services6": "過敏的成因，是由於我們的免疫系統為抵抗塵蟎、花粉、寵物皮屑、昆蟲叮咬、藥物或特定類型食物等外來物質或過敏原，而產生的負面反應。假如您因接觸過敏原而導致咳嗽、打噴嚏或氣喘，您便對這種過敏原有過敏反應。",
    "services7": "我們的皮膚測試簡單而準確，適合六歲或以上兒童，成年人以至長者使用。您將會透過測試迅速了解自己可能有什麼過敏問題。",
    "services8": "在測試是否患上哮喘之前，本診所先會按客戶的情況制訂個別的治療方案，從而讓每位病人知道必須採取什麼措施，來解決他們在家中可能會遇到的身體問題。",
    "services9": "我們的過敏和哮喘計劃亦包括量度六歲或以上年輕呼吸道患者的肺功能。同時，專家我們會為年輕的哮喘患者制訂治療方案，讓他們可以放心參加大部份的日常活動。",
    "services10": "兒童測試是專為遏止過敏反應而設計，以確保您的子女不必擔心接觸到過敏原，以及能獲得針對性的治療。",
    "services11": "除了環境控制免疫療法 (過敏注射) 和常規的過敏免疫療法外，我們在這方面的治療方法亦包括抗免疫球蛋白E療法。我們所提供的一切哮喘相關服務，都可包含為孕婦度身訂造的教育和治療計劃。",
    "services12": "慢阻肺病、肺氣腫和支氣管擴張計劃。",
    "services13": "我們的診所設有肺功能測試設備，並且在有需要時可安排轉介電腦掃描、正電子掃描和磁力共振掃描等服務。為教育患者和他們的家人有關疾病的知識，我們的跨科慢阻肺病計劃詳細提供了適當的方法來進行呼吸護理，包括吸入器的使用、氧氣治療和設備運用，節能和營養等。合適的病人更將獲得持續醫療管理和評估混合服務，以便接受肺減量或移植手術。",
    "services14": "對患有反復咳嗽、呼吸困難，肺結節、復發性肺炎和阻塞性睡眠呼吸暫停等一般肺部疾病的病人，我們亦會提供諮詢和治療服務。",
    "services15": "肺功能測試",
    "services16": "肺功能測試評估可用來檢測患者呼吸功能的潛在異常情況，以及確定任何肺部疾病的嚴重程度。這些測試亦可協助診斷哮喘、過敏、呼吸道感染等疾病。",
    "services17": "肺量測試",
    "services18": "我們的電腦化肺活量測試系統，可量度患者肺部能容納的空氣量以及呼氣的力量，有助確定肺部的健康狀況以制訂改善方案。這套系統亦能讓我們評估病人對治療有何反應，以及肺部疾病有否惡化。",
    "services19": "評估及管理睡眠障礙",
    "services20": "您是否難以入睡？一整天都感到異常地疲倦？您的枕邊人會否說您睡覺時會有嘈吵的鼻鼾聲或停止呼吸？如是，您可能已經患上阻塞性睡眠呼吸暫停等睡眠失調症。當評估過您的睡眠情況以確定問題的根源後，我們將會詳細解釋您必須做的事情，以享受健康生活不可或缺的優質睡眠。",
    "services21": "支氣管鏡檢查",
    "services22": "我們會透過支氣管鏡，亦即一條十分靈活且安裝了攝影機的幼長光纖管，來診斷腫瘤、收集樣本，以及尋找並清除病人肺部中的異物。",
    "services23": "心電圖",
    "services24": "由心臟開始傳播至身體不同部位的不規則電脈衝，是另一個顯示潛在健康問題的有效早期指標。我們的心電圖診斷量度及監察測試簡單且易於使用，對於希望評估並開始保障健康的患者而言，接受這項測試絕對是正確的選擇。",
    "services25": "癌症篩查",
    "services26": "考慮到並非所有癌症患者都會出現早期症狀，我們會因應病人的獨特個人風險因素而提供全面的癌症篩查服務，從而測試表面看來健康的人士是否患有早期的惡性腫瘤。",
    "services27": "協助戒煙服務",
    "services28": "每個吸煙者都有可能患上嚴重的肺部或心血管疾病，甚至是致命的癌症，因此請坐言起行，立即戒煙！我們了解到戒煙計劃必須成為吸煙者生活的一部份，誠恩醫療戒煙計劃包括一份完整的醫療評核報告，以及長遠戒煙策略，讓您從此遠離煙草！",
    "services29": "預約健康檢查",
    "services30": "本公司亦提供各種定期檢查選擇以評估您的一般健康狀況。透過健康檢查套餐的主要健康指標，我們篩查的常見疾病包括：<br />› 心血管疾病<br />› 糖尿病<br />› 腎病<br />› 肝病<br />› 甲狀腺疾病<br />› 貧血<br />› 感染等",
    "services31": "接受過檢查的每位病人，將會取得一份詳細的電子版檢查報告。",
    "services32": "外遊疫苗接種服務",
    "services33": "雖然大部份可依靠疫苗來預防的疾病已在香港根除，但這些疾病在很多國家仍然相當常見。目前，每天有超過250萬人在世界不同的角落穿梭往來，我們必須常常在出發前接種疫苗，以免自己因感染疾病而耽誤旅程甚至可能危及性命。",
    "services34": "誠恩醫療時刻盡力確保為任何年齡的外遊人士，提供最完善的疫苗接種服務，對象遍及兒童、青少年、年輕專業人士以至資深的外遊者。除了年度流感疫苗外，我們亦提供針對甲型肝炎、乙型肝炎、人類乳頭瘤病毒(HPV)、肺炎球菌和帶狀皰疹等病毒的全方位預防疫苗。",

    "contactUs1": "聯絡 <span>我們</span>",
    "contactUsPhone": "電話",
    "contactUsFax": "傳真",
    "contactUsEmail": "電郵",
    "contactUsLocation": "診所地址",
    "contactUsAddress": "中環皇后大道中33號<br />萬邦行8樓807室"
};
